import React, {Component} from "react";
import TrustPosition from "./TrustPositionView";
import {Growl} from "primereact/growl";
import {TrustPositionService} from "../../service/admin/trustPosition/TrustPositionService";

export default class TrustPositionContainer extends Component {
    constructor(props) {
        super(props);
        this.trustPositionService = new TrustPositionService();
        this.getDataPositions = this.getDataPositions.bind(this);

        this.state = {
            dataPositions: this.getDataPositions('0'),
            contratoConsulta: '',
            isLoading: true,
        };

        this.onChangeTextFilter = this.onChangeTextFilter.bind(this);
        this.searchContract = this.searchContract.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.loading = this.loading.bind(this);
    }

    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    fillDataPositions(dataPositions) {
        this.setState({
            dataPositions: dataPositions,
            isLoading: false,
        })
    }

    getDataPositions(contrato) {
        this.loading();
        return this.trustPositionService.getDataPositions(contrato)
            .then(dataPositions => {
                this.fillDataPositions(dataPositions);
            });
    }

    onChangeTextFilter(event) {
        const {value} = event.target;
        this.setState({contratoConsulta: value,})
    }

    searchContract() {
        let contract = this.state.contratoConsulta === '' ? '0' : this.state.contratoConsulta;

        this.setState({
            dataPositions: this.getDataPositions(contract),
        })
    }

    clearFilters() {
        this.setState({contratoConsulta: ''})
    }

    render() {

        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {dataPositions, contratoConsulta, isLoading} = this.state;

        return <TrustPosition dataPositions={dataPositions}
                              messagesGrowl={messagesGrowl}
                              onChangeTextFilter={this.onChangeTextFilter}
                              contratoConsulta={contratoConsulta}
                              searchContract={this.searchContract}
                              clearFilters={this.clearFilters}
                              isLoading={isLoading}
        />

    }
};